import { BehaviorSubject } from 'rxjs';
import { LayerStyle, MapboxLayerType } from './layer.type';
import { LayerGroup } from './layer-group.model';

export abstract class BaseLayer {
  abstract id: string;
  abstract name: string;
  abstract style?: { layerType?: MapboxLayerType; } & LayerStyle | { layerType?: 'html-marker'; sourceType?: 'geojson'; } & LayerStyle;

  protected abstract mapRef: mapboxgl.Map;
  protected abstract isVisibleBS: BehaviorSubject<boolean>;

  protected layerGroup: LayerGroup;

  protected readonly isSelectedBS = new BehaviorSubject(false);
  public readonly isSelected$ = this.isSelectedBS.asObservable();

  public toggleIsSelected() {
    this.setIsSelected(!this.isSelectedBS.getValue());
  }
  public setIsSelected(selected: boolean) {
    this.isSelectedBS.next(selected);
    const isGroupVisible = this.layerGroup?.getIsVisible();
    if (isGroupVisible) {
      this.setVisibility(selected);
    } else {
      this.setVisibility(false);
    }
  }
  public getIsSelected() {
    return this.isSelectedBS.getValue();
  }
  public setVisibility(isVisible: boolean, forceGroupVisibility = false) {
    if (this.layerGroup && forceGroupVisibility) {
      this.setIsSelected(isVisible);
      this.layerGroup.setVisibility(isVisible);
    } else {
      console.log(isVisible ? `Show ${this.name}` : `Hide ${this.name}`);
      if (this.mapRef.getLayer(this.id)) {
        console.log(isVisible ? `Show` : `Hide`, 'native layer');
        this.mapRef.setLayoutProperty(this.id, 'visibility', isVisible ? 'visible' : 'none');
      }
      this.style.visible = isVisible;
      this.isVisibleBS.next(isVisible);
    }
  }
  public setLayerGroup(group: LayerGroup) {
    this.layerGroup = group;
  }
}
